import modelBaseV2 from "../model-base-v2.model";

const DOWNLOAD_FILE = {
  URL: '/api/executesp/export/commonexcel',
  STORED_PROCEDURE_CODE: '54',
  PARAM_CODE: {
    PAGE_SITE: '4',
    PAGE_NO: '99',
    FROM_DATE: '8',
    TO_DATE: '9',
    INPUT_USER_LANGUAGE_CODE: '17',
    CUSTOMER: '90',
    CHANNEL: '104',
    FSM_USER_ID: '105',
    ACCEPT_YN: '106',
    IMEI_SERIAL_NUMBER: '107',
    IMEI_SERIAL_TYPE: '108',
    TO_MATCH_FLAG: '109'
  }
}

const SMSLogFSMModel = {
  getSMSLogFSM: (body) => modelBaseV2.post('/api/sms/fsm/logs', { body }),
  excelDownload: (body, fileName = 'template') => {
    const downloadConfig = {
      storedProcedureCode: DOWNLOAD_FILE.STORED_PROCEDURE_CODE,
      params: [
        {
          code: DOWNLOAD_FILE.PARAM_CODE.PAGE_SITE,
          value: '-1'
        },
        {
          code: DOWNLOAD_FILE.PARAM_CODE.PAGE_NO,
          value: '1'
        },
        {
          code: DOWNLOAD_FILE.PARAM_CODE.FROM_DATE,
          value: body.dateFrom
        },
        {
          code: DOWNLOAD_FILE.PARAM_CODE.TO_DATE,
          value: body.dateTo
        },
        {
          code: DOWNLOAD_FILE.PARAM_CODE.INPUT_USER_LANGUAGE_CODE,
          value: body.inputUserLanguageCode
        },
        {
          code: DOWNLOAD_FILE.PARAM_CODE.CUSTOMER,
          value: body.customerCodes
        },
        {
          code: DOWNLOAD_FILE.PARAM_CODE.CHANNEL,
          value: body.siteIds
        },
        {
          code: DOWNLOAD_FILE.PARAM_CODE.FSM_USER_ID,
          value: body.fsmId
        },
        {
          code: DOWNLOAD_FILE.PARAM_CODE.ACCEPT_YN,
          value: body.accept
        },
        {
          code: DOWNLOAD_FILE.PARAM_CODE.IMEI_SERIAL_NUMBER,
          value: body.imeiOrSerialNo
        },
        {
          code: DOWNLOAD_FILE.PARAM_CODE.IMEI_SERIAL_TYPE,
          value: body.type
        },
        {
          code: DOWNLOAD_FILE.PARAM_CODE.TO_MATCH_FLAG,
          value: body.toMatchFlag
        }
      ]
    }
    return modelBaseV2.postDownload(
      DOWNLOAD_FILE.URL,
      { body: downloadConfig },
      fileName
    )
  }

}

export default SMSLogFSMModel